import { Disc3, Sparkles, Waves, Zap } from 'lucide-react';

const GENRES = [
  { title: "Hindustani Classical", icon: Disc3, desc: "The foundational tradition. Built on complex raga systems and tala cycles, this is the purest expression of sitar artistry — meditative alap, rhythmic jod, and exhilarating jhala.", color: "#d4af37" },
  { title: "Carnatic Fusion", icon: Waves, desc: "A cross-pollination with South Indian classical traditions, blending Hindustani sitar techniques with Carnatic melodic structures and rhythmic complexity.", color: "#e5c35b" },
  { title: "Indo-Jazz Fusion", icon: Sparkles, desc: "Pioneered by artists like Ravi Shankar with jazz legends. This genre marries raga improvisation with jazz harmony, creating a transcendent new musical language.", color: "#22c55e" },
  { title: "Contemporary & Electronic", icon: Zap, desc: "Modern sitar artists are pushing boundaries with electronic production, ambient textures, and cross-genre collaborations that bring ancient sounds into the digital age.", color: "#a855f7" },
];

export default function GenresSection() {
  return (
    <section id="genres" data-testid="genres-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4">Traditions & Innovation</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-4 tracking-tight">
            Music Styles & Genres
          </h2>
          <p className="text-[#a3b1c6] max-w-xl mx-auto text-base">
            The sitar speaks through many musical dialects
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {GENRES.map((genre) => {
            const Icon = genre.icon;
            return (
              <div
                key={genre.title}
                data-testid={`genre-card-${genre.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="bg-[#122036] border border-[#d4af37]/20 rounded-xl p-8 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(212,175,55,0.1)] transition-all duration-300 group"
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${genre.color}15`, border: `1px solid ${genre.color}40` }}>
                    <Icon className="w-5 h-5" style={{ color: genre.color }} />
                  </div>
                  <h3 className="font-['Cormorant_Garamond'] text-2xl text-[#fdfbf7] group-hover:text-[#d4af37] transition-colors">{genre.title}</h3>
                </div>
                <p className="text-[#a3b1c6] text-sm leading-relaxed">{genre.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="section-divider mt-24 md:mt-32 max-w-4xl mx-auto" />
    </section>
  );
}
